import styled from 'styled-components';
import { device } from '@styles/tools/breakpoints.styles';

export const StyledSection = styled.section`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.forms.borderRadius}px;
  ${props =>
    !props.noGutter &&
    `
    padding: ${props.theme.space[3]}px;
  `}

  ${device.mobile} {
    padding: ${props => (props.noMobilePadding ? 0 : `${props.theme.space[1]}px ${props.theme.space[2]}px`)};
  }
`;
